export const EVENT_SUFFIXES = {
    SUCCESS: "success",
    OPEN: "open",
    CLOSE: "close",
    MORE: "more",
    WITHDRAW: "withdraw",
} as const;

export type EventSuffix = keyof typeof EVENT_SUFFIXES;
